import Axios from "axios";
import GetNoticesReq from "../types/getNoticesRequest";
import axiosClient from "./axiosClient";

export default async function getNotices(bodyRequest: GetNoticesReq) {
  try {
    const response = await axiosClient.post(`/notices/getNotices`, bodyRequest);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}
